export default "__VITE_ASSET__nRshI5vh__"